import React from "react";
import { Page, View, Text, Image, StyleSheet } from "@react-pdf/renderer";
import { PDF_PAGE } from "../../constants/pdfSizes";
import defaultCover from "../../assets/hotelBg.jpg";
import hotelIcon from "../../assets/hotelIcon.png";

const styles = StyleSheet.create({
  page: {
    width: PDF_PAGE.width,
    height: PDF_PAGE.height,
    position: "relative",
    backgroundColor: "#000",
  },
  background: {
    position: "absolute",
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  overlay: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(6, 5, 45, 0.54)",
  },
  container: {
    paddingTop: 10,
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
  },
  icon: {
    width: 40,
    height: 44,
    marginBottom: 4,
  },
  title: {
    fontFamily: "Montserrat",
    fontSize: 44,
    textAlign: "center",
    color: "#fff",
    fontWeight: "medium",
    marginBottom: 0,
  },
  subtitle: {
    fontFamily: "Montserrat",
    fontSize: 20,
    textAlign: "center",
    color: "#fff",
    marginBottom: 10,
  },
  optionBox: {
    marginVertical: 12,
    borderWidth: 1.5,
    borderColor: "#987328",
    borderRadius: 8,
    paddingBottom: 8,
    width: "90%",
    backgroundColor: "rgba(255,255,255,0.05)",
  },
  optionLabel: {
    backgroundColor: "#fff",
    borderRadius: 6,
    paddingVertical: 6,
    paddingHorizontal: 14,
    alignSelf: "center",
    marginTop: -14,
    marginBottom: 12,
    borderWidth: 1,
    borderColor: "#987328",
  },
  optionLabelText: {
    fontSize: 13,
    fontWeight: "bold",
    fontFamily: "Montserrat",
    color: "#090F49",
    textAlign: "center",
  },
  tableHeader: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderColor: "#987328",
    paddingVertical: 6,
    paddingHorizontal: 6,
  },
  tableRow: {
    flexDirection: "row",
    borderBottomWidth: 0.5,
    borderColor: "#987328",
    paddingVertical: 3,
    paddingHorizontal: 4,
  },
  colHeader: {
    flex: 1,
    textAlign: "left",
    fontSize: 12,
    fontWeight: "semibold",
    color: "#fff",
    fontFamily: "Montserrat",
      paddingVertical: 0,
    paddingHorizontal: 0,
  },
  col: {
    flex: 1,
    textAlign: "center",
    fontSize: 12,
    color: "#fff",
    fontFamily: "Montserrat",
    fontWeight: "semibold",
  },
 
});

const HotelSlide = ({
  bg,
  icon = hotelIcon,
  title = "HOTELS DETAILS",
  subtitle = "The Perfect Blend Of Luxury",
  hotelGroups = [],
}) => {
  const backgroundImage = bg || defaultCover;
  return (
    <Page size={PDF_PAGE} style={styles.page}>
      <Image src={backgroundImage} style={styles.background} />
      <View style={styles.overlay} />

      <View style={styles.container}>
        {icon && <Image src={icon} style={styles.icon} />}
        <Text style={styles.title}>{title}</Text>
        <Text style={styles.subtitle}>{subtitle}</Text>

        {hotelGroups.length === 0 ? (
          <Text style={styles.subtitle}>No hotel options available</Text>
        ) : (
          hotelGroups.map((group, i) => (
            <View key={i} style={styles.optionBox}>
              <View style={styles.optionLabel}>
                <Text style={styles.optionLabelText}>
                  {group.groupName || `HOTEL OPTION ${i + 1}`}
                </Text>
              </View>

              <View style={styles.tableHeader}>
                <Text style={[styles.colHeader, { textAlign: "left" }]}>Date</Text>
                <Text style={[styles.colHeader, { textAlign: "left" }]}>Location</Text>
                <Text style={[styles.colHeader, { textAlign: "left",  flexGrow : 2, }]}>Hotel Name</Text>
                <Text style={styles.colHeader}>Star Category</Text>
                <Text style={styles.colHeader}>Room Type</Text>
                <Text style={styles.colHeader}>No. Rooms</Text>
                <Text style={styles.colHeader}>Meal Plan</Text>
                <Text style={styles.colHeader}>Room Category</Text>
              </View>

              {group.hotels.length === 0 ? (
                <Text style={styles.subtitle}>No hotels available for this option</Text>
              ) : (
                group.hotels.map((h, idx) => (
                  <View key={idx} style={styles.tableRow}>
                    <Text style={[styles.col, { textAlign: "left" }]}>{h.date || "--"}</Text>
                    <Text style={[styles.col, { textAlign: "left" }]}>{h.location || "--"}</Text>
                    <Text style={[styles.col, { textAlign: "left",  flexGrow : 2, }]}>{h.hotelName || "--"}</Text>
                    <Text style={styles.col}>{h.starCategory || "--"}</Text>
                    <Text style={styles.col}>{h.roomType || "--"}</Text>
                    <Text style={styles.col}>{h.numRooms || "--"}</Text>
                    <Text style={styles.col}>{h.mealPlan || "--"}</Text>
                    <Text style={styles.col}>{h.roomCategory || "--"}</Text>
                  </View>
                ))
              )}
            </View>
          ))
        )}
      </View>
    </Page>
  );
};

export default HotelSlide;
